export const typesReports = {
  orderItems: 'order-items',
  valuationOrder: 'valuation-order',
  selectedsByAgency: 'selecteds-by-agency',
  ordersCosts: 'orders-costs',
  minorsCasting: 'escalacao-menor',
  minorLicense: 'alvara-menor',
  conciergeSecurity: 'portaria-seguranca',
  insurance: 'seguros',
  ordersAgency: 'agencia-figuracao',
  blockedFigurants: 'figurantes-bloqueados',
  summaryOrder: 'custo-por-pedido',
};

export const typesReportsTranslate: Record<string, string> = {
  'order-items': 'pedidos-itens',
  'valuation-order': 'pedidos-com-valoracao',
  'selecteds-by-agency': 'escalacao-periodo-agencia',
  'orders-costs': 'pedido-custo',
};
